import { render, staticRenderFns } from "./OurHeading.vue?vue&type=template&id=6316a47e&"
import script from "./OurHeading.vue?vue&type=script&lang=js&"
export * from "./OurHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports